import React, { useState, useEffect } from "react";
import Modal from "../../common/Modal/Modal";
import { HelpOutline } from "@mui/icons-material";

import "./MapsModal.css";

export default function MapsModal() {
  // Initialising UseStates
  const [openModal, setOpenModal] = useState(false);
  const [mapsData, setMapsData] = useState([]);

  // Handle Open/Close Functionality
  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  // useEffect to fetch and set data when the component mounts
  useEffect(() => {
    // Asynchronously import JSON data from a file
    import("../../../data/Tooltips/tooltips.json")
      .then((tooltips) => {
        // Set the mapsData state with the "Maps" property from the imported JSON
        setMapsData(tooltips.Maps);
      })
      .catch((error) => {
        console.error("Error loading data:", error);
      });
  }, []); // The empty dependency array ensures this effect runs once when the component mounts

  return (
    <div className="maps-tooltips-modal">
      <div className="maps-modal-tooltip">
        {/* Button to open the modal */}
        <button className="maps-modal-button" onClick={handleOpenModal}>
          <HelpOutline />
        </button>

        {/* Modal component */}
        <Modal
          isOpen={openModal} // Modal open/close state
          onClose={handleCloseModal} // Event handler to close the modal
          title={"Maps Information"} // Modal title
          showCustomContent={true} // Flag to display custom content
          customContent={
            <div>
              {/* Render Maps data */}
              {mapsData.map((item, index) => (
                <div className="general-tooltips-content" key={index}>
                  <p className="maps-text">
                    <span>{item.key}</span> : {item.description}
                  </p>
                </div>
              ))}
            </div>
          }
        />
      </div>
    </div>
  );
}
